export const tenantId = window.location.pathname.split("/")[1];
